import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from "sweetalert2/dist/sweetalert2.js";

const toast = Swal.mixin({
    toast: true,
    position: "top",
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false
});
    

const showErrorNotifications = (notifications) => {
    if (!notifications) { return; }

    let message = "";
    
    for(let index = 0; index < notifications.length; index++) {                                                                     
        message += `${index + 1} - ${notifications[index].message} \n`
    }
    
    toast.fire(message, "", "error");
}

const showErrorNotificationsWithTitle = (title, notifications) => {
    if (!title) { return; }
    if (!notifications) { return; }

    let message = "";         
    notifications.unshift(title);

    for(let index = 0; index < notifications.length; index++) {
        message += `${index + 1} - ${notifications[index].message} \n`
    }

    toast.fire(message, "", "error");
}

const showToastNonIntertConnection = () => {
    toast.fire("Não foi possível conectar-se a internet", "", "warning");
}

const showToastSuccess = (message) => {
    toast.fire(message, "", "success")
}

const showToastWarning = (message) => {    
    toast.fire(message, "", "warning");
}

const showErrorModal = (message) => {
    Swal.fire("Erro", message, "error");
    
}

const showSuccessModal = (message) => {
    Swal.fire("Sucesso", message, "success");
}

const showWarningModal = (message) => {
    Swal.fire("Alerta", message, "warning");
}

const confirmOperation = async (title, text) => {
    let result = await Swal.fire({
        title, 
        text,               
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sim',
        denyButtonText: 'Não',                
        customClass: {
            actions: 'my-actions',                  
            confirmButton: 'order-1',
            denyButton: 'order-3',
        }
        });

    if (!result.isConfirmed) { return false; }
    else { return true; }   
}   

export {
    showErrorNotifications,
    showErrorNotificationsWithTitle,
    showToastNonIntertConnection,
    showErrorModal,
    showSuccessModal,
    showWarningModal,
    confirmOperation,
    showToastSuccess,
    showToastWarning    
}


